const speciality = [
  {
    _id: "1",
    label: "Anesthesiology",
  },
  {
    _id: "2",
    label: "Cardiology",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  {
    _id: "3",
    label: "Dentist Adult",
    bestClinicId: "691f4b15ace4c65b98666637",
  },
  {
    _id: "3.1",
    label: "Dentist Pediatric",
    bestClinicId: "691f4b15ace4c65b98666637",
  },
  {
    _id: "4",
    label: "Dermatology",
  },
  {
    _id: "5",
    label: "ENT",
  },
  {
    _id: "6",
    label: "Family Medicine",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  {
    _id: "7",
    label: "Haematology   ",
  },
  {
    _id: "8",
    label: "Infectious Disease",
  },
  {
    _id: "9",
    label: "Internal Medicine",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  {
    _id: "10",
    label: "Nutritionist",
  },
  {
    _id: "11",
    label: "Obstetric Gynecology",
    bestClinicId: "695bc26847b4e8a4fa8defbb",
  },
  {
    _id: "12",
    label: "Oncology",
  },
  {
    _id: "13",
    label: "Orthopedic ",
  },
  {
    _id: "14",
    label: "Pediatrics",
    bestClinicId: "68f91aebb1bcffb6d40555aa",
  },
  {
    _id: "15",
    label: "Psychiatry",
  },
  {
    _id: "16",
    label: "Pulmonology",
  },
  {
    _id: "17",
    label: "Surgery-General ",
  },
  {
    _id: "18",
    label: "Surgery-Neuro",
  },
  {
    _id: "19",
    label: "Surgery-Orthopedic",
  },
  {
    _id: "20",
    label: "Other",
  },
  {
    _id: "21",
    label: "CardioThoracic Surgery",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  {
    _id: "22",
    label: "Vascular Surgery",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  {
    _id: "23",
    label: "Pediatric Neurology",
    bestClinicId: "68f9affba47795f978b84b9a",
  },
  { _id: "24", label: "Rheumatology" },
  { _id: "25", label: "Nephrology" },
  { _id: "26", label: "Gastroenterology" },
  { _id: "27", label: "Endocrinology" },
  { _id: "28", label: "Radiology" },
  { _id: "29", label: "Emergency Medicine" },
  { _id: "30", label: "Urology" },
  { _id: "31", label: "Ophthalmology" },
  { _id: "32", label: "Plastic & Reconstructive Surgery" },
  { _id: "33", label: "Geriatrics" },
  { _id: "34", label: "Palliative Care" },
  { _id: "35", label: "Occupational Medicine" },
  { _id: "36", label: "Sports Medicine" },
  { _id: "37", label: "Allergy & Immunology" },
  { _id: "38", label: "Medical Genetics" },
  { _id: "39", label: "Critical Care / ICU" },
  { _id: "40", label: "Hepatology" },
  { _id: "41", label: "Pain Management" },
  { _id: "42", label: "Sleep Medicine" },
  { _id: "43", label: "Toxicology" },
];

export default speciality;
